// Function loadEcommerceBlock loads the EcommerceBlock class by dynamically importing the js on demand if needed

export function loadEcommerceBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-ecommerce-block-chunk" */ '../widgets/ecommerceBlock').then(wg => {

		const { EcommerceBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="EcommerceBlock"]');

		if(!$wg) {
			// console.info('EcommerceBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="EcommerceBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new EcommerceBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new EcommerceBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the EcommerceBlock widget');

}
